export const getTagsIntersection = (tagsArrays: string[][]) => {
  if (tagsArrays.length === 0) return [];

  return tagsArrays.reduce((join, current) => join.filter((tag) => current.includes(tag)));
};
